import { ThemeEvents, CartUpdateEvent } from "@theme/events";

/**
 * The Goddess Circle subscription product (discontinued, no longer sold) —
 * some shoppers still have it in their cart from a stale link/cache or an
 * old add-to-cart form. This variant/selling-plan combo must never remain
 * in a live cart.
 * https://aweinspired.com/products/the-goddess-circle?selling_plan=1914634292&variant=43924490027060
 */
const LEGACY_SUBSCRIPTION_VARIANT_ID = 43924490027060;

const SOURCE = "awe-remove-legacy-subscription";

let checkInProgress = false;

async function removeLegacySubscriptionProduct() {
  if (checkInProgress) return;
  checkInProgress = true;

  try {
    const cartResponse = await fetch("/cart.js");
    if (!cartResponse.ok) return;
    const cart = await cartResponse.json();

    const line = cart.items?.find(item => item.id === LEGACY_SUBSCRIPTION_VARIANT_ID);
    if (!line) return;

    const cartSectionId = document.querySelector("cart-items-component")?.dataset.sectionId ?? null;
    const body = { id: line.key, quantity: 0 };
    if (cartSectionId) {
      body.sections = cartSectionId;
      body.sections_url = window.location.pathname;
    }

    const removeResponse = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    if (!removeResponse.ok) return;

    const data = await removeResponse.json();
    const sections =
      cartSectionId && data.sections?.[cartSectionId] ? { [cartSectionId]: data.sections[cartSectionId] } : undefined;

    document.dispatchEvent(new CartUpdateEvent(data, SOURCE, { source: SOURCE, sections }));
  } catch (err) {
    console.error("[awe-remove-legacy-subscription] Failed to remove legacy product:", err);
  } finally {
    checkInProgress = false;
  }
}

removeLegacySubscriptionProduct();

// Re-check on every cart update (e.g. a stale add-to-cart form on a cached page
// adds the product after this script's initial check already ran).
document.addEventListener(ThemeEvents.cartUpdate, event => {
  if (event.detail?.data?.source === SOURCE) return;
  removeLegacySubscriptionProduct();
});
